module.exports = __webpack_public_path__ + "img/brand.187d9e40.svg";